import { FC } from "react";
import littleGuy from "../../TDD-Images/buddy.png";
import TrackProgress from "./TrackProgress";
import trophy from "../../TDD-Images/trophy.png";

interface Props {
  track: string;
  trackDescription: string;
  trackTime: string;
  readinessLevel: number;
  totalQuestions: number;
  questionsPracticed: number;
  stars: number;
}

const TrackHero: FC<Props> = ({
  track,
  trackDescription,
  trackTime,
  questionsPracticed,
  readinessLevel,
  stars,
  totalQuestions,
}) => {
  return (
    <div className="w-full text-left">
      <div className="gap-4 flex justify-between items-center w-full">
        <div className="w-1/2 flex justify-center items-center gap-4">
          <img src={littleGuy} alt="little guy" className="w-[90px]" />
          <div className="flex flex-col w-full gap-4">
            <div className="flex items-center justify-between">
              <p className="p-0 m-0 text-[24px] text-[#3E4784] font-semibold">
                {track}
              </p>
              {/* <p className="p-0 m-0 border px-2 py-1 border-[#E9EAEB] rounded-[16px] text-[12px] font-medium">
                {trackTime}
              </p> */}
            </div>
            {<p className="m-0 p-0 text-[14px]">{trackDescription}</p>}
          </div>
        </div>
        {/* <div className="w-[450px] mr-[50px] flex justify-center items-center">
          <div className="flex flex-col w-full gap-4">
            <p className="p-0 m-0 text-[16px] text-[#101323]">
              Readiness Level {readinessLevel}
            </p>
            <div className="w-full flex items-center gap-4">
              <div className="flex flex-col gap-2">
                <TrackProgress
                  value={questionsPracticed}
                  total={totalQuestions}
                  label="Questions Practiced"
                />
                <TrackProgress
                  value={stars}
                  total={totalQuestions * 3}
                  label="Stars"
                />
              </div>
              <img src={trophy} alt="trophy" className="w-[90px]" />
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default TrackHero;
